// @flow
import {encodeRouteForQuery} from "./queryHistory";

/**
 * Builds a dealer shop URL in the dealer's shop routing (the backend flag
 * `Dealership.shopRouting`). Mirrors ShopUrlBuilder.build in product-catalog-rest-api so links
 * built here and links built by feed, sitemap and mails are identical.
 */

export const SHOP_ROUTING = Object.freeze({HASH: "HASH", QUERY: "QUERY", PATH: "PATH"});
export const QUERY_PARAM_NAME = "shop";

const stripFragment = (url: string): string => {
    const hash = url.indexOf("#");
    return hash >= 0 ? url.substring(0, hash) : url;
};

const normalizeRoute = (route: ?string): string => {
    if (!route || !route.trim()) {
        return "/";
    }
    return route.startsWith("/") ? route : `/${route}`;
};

export const buildShopUrl = (shopBaseUrl: string, routing: ?string, route: ?string): string => {
    if (!shopBaseUrl || !shopBaseUrl.trim()) {
        throw new Error("shopBaseUrl must not be blank");
    }
    const normalizedRoute = normalizeRoute(route);
    const base = stripFragment(shopBaseUrl);

    switch ((routing || SHOP_ROUTING.HASH).toUpperCase()) {
        case SHOP_ROUTING.QUERY:
            return normalizedRoute === "/"
                ? base
                : `${base}${base.includes("?") ? "&" : "?"}${QUERY_PARAM_NAME}=${encodeRouteForQuery(normalizedRoute)}`;
        case SHOP_ROUTING.PATH: {
            const queryStart = base.indexOf("?");
            const path = queryStart >= 0 ? base.substring(0, queryStart) : base;
            const query = queryStart >= 0 ? base.substring(queryStart) : "";
            return `${path.replace(/\/$/, "")}${normalizedRoute}${query}`;
        }
        default:
            return `${base}#${normalizedRoute}`;
    }
};
